import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import { getUserItemInteractionId } from 'bundles/author-assignment-grading/utils/common';

const auditTrailV1 = API('/api/auditTrailHistory.v1', { type: 'rest' });

export const getAuditTrailByUserItem = (userId: string | number, courseBranchId: string, itemId: string) => {
  const uri = new URI(getUserItemInteractionId(userId, courseBranchId, itemId)).addQueryParam(
    'fields',
    'userItemActions,profileNames'
  );

  return Q(auditTrailV1.get(uri.toString())).then(
    (result) =>
      (result.elements && {
        logs: result.elements[0].userItemActions,
        profileNames: result.elements[0].profileNames,
      }) || { logs: [], profileNames: {} }
  );
};
